const enfinValidator = (formVals: object) => {
  if (!formVals) return 'This form is not valid, please try again'
}

const VALIDATORS_BY_INTEGRATION = {
  enfin: enfinValidator,
}
export default VALIDATORS_BY_INTEGRATION
